import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m3.682 8.731a1 1 0 1 0-1.364-1.462l-3.604 3.363-1.032-.963a1 1 0 1 0-1.364 1.462l1.714 1.6a1 1 0 0 0 1.365 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_circle_check_filled-ZIwAVPGE.js.map
